/* tslint:disable:max-line-length */
import { ESwitcherAssetType } from "../../../domain/broadcasts/switcher-item.type.enum";
import {
  BroadcastPresetViewModel,
  EKeymapShortcutsPerMedia,
} from "./broadcast-preset.view-model";
import { SwitcherViewModel } from "./switcher.view-model";
import { LayoutZoneViewModel } from "../../layouts/view-models/layout.view-model";
import { UI } from "../../../services/ui.service";
import { SwitcherItem } from "../../../domain/broadcasts/switcher-item";
import { IBroadcastsRepository } from "../../../domain/broadcasts/i-broadcasts-repository";
import { ChangeDetectorRef } from "@angular/core";
import {
  assetBlockItemExtendedData,
  broadcastAssetItemExtendedData,
} from "app/js/src/domain/broadcasts/asset-block-item-extended-data";
import { Subject } from "rxjs";

export class SwitcherItemViewModel extends SwitcherItem {
  public isProccesing: boolean = false;
  public assetsCount: number = 1;
  public dataChanged$ = new Subject<void>();
  public get shortcutLabel(): string {
    return EKeymapShortcutsPerMedia[this.index];
  }
  constructor(
    switcherItem: SwitcherItem,
    private _changeDetectorRef: ChangeDetectorRef,
    private _ui: UI,
    private _broadcastsPresetsRepository: IBroadcastsRepository,
  ) {
    super(
      switcherItem.uid,
      switcherItem.type,
      switcherItem.index,
      switcherItem.assetName,
      switcherItem.previewUrl,
      switcherItem.assetId,
      switcherItem.somMs,
      switcherItem.durationMs,
      switcherItem.volumeEnabled,
      switcherItem.isProgram,
      switcherItem.isPreview,
      switcherItem.data,
      switcherItem.colSpan ?? 1,
      switcherItem.rowSpan ?? 1,
    );
  }
  public toggleVolumeClicked() {
    this.volumeEnabled = !this.volumeEnabled;
  }

  public toEmpty() {
    this.data = null;
    this.previewUrl = null;
    this.assetId = 0;
    this.somMs = 0;
    this.durationMs = 0;
    this.assetsCount = 0;
    this.volumeEnabled = false;
    this.isProgram = false;
    this.isPreview = false;
    this.colSpan = 1;
    this.rowSpan = 1;
    return (this.type = ESwitcherAssetType.Empty);
  }

  getTitle(): string {
    return `${ESwitcherAssetType[this.type]}: ${this.assetName}`;
  }

  resetState() {
    this.isProgram = false;
    this.isPreview = false;
  }
  public get isStack(): boolean {
    return this.type === ESwitcherAssetType.Stack;
  }
  public get isBlock(): boolean {
    return this.type === ESwitcherAssetType.Block;
  }
  public get isLiveFeed(): boolean {
    return this.type === ESwitcherAssetType.LiveFeed;
  }

  mergeWith(anotherItem: SwitcherItemViewModel) {
    this.assetName = anotherItem.assetName;
    this.assetId = anotherItem.assetId;
    this.type = anotherItem.type;
    this.previewUrl = anotherItem.previewUrl;
    this.isProccesing = anotherItem.isProccesing;
    this.isPreview = anotherItem.isPreview;
    this.somMs = anotherItem.somMs;
    this.durationMs = anotherItem.durationMs;
    this.data = anotherItem.data;
    this._changeDetectorRef.detectChanges();
    this._changeDetectorRef.markForCheck();
    // Notify components that data has changed
    this.dataChanged$.next();
  }

  public onPreviewError(event: Event) {
    const target = event.target as HTMLImageElement;
    switch (this.type) {
      case ESwitcherAssetType.Gfx:
        target.src = "/assets/icons/graphics-icon.svg";
        break;
      case ESwitcherAssetType.Layout:
        target.src = "/assets/icons/layout-icon.svg";
        break;
      case ESwitcherAssetType.Media:
        target.src = "/assets/icons/video-icon.svg";
        break;
      case ESwitcherAssetType.LiveFeed:
        target.src = "/assets/icons/live-icon.svg";
        break;
      default:
        target.src = "";
        break;
    }
    target.style.display = "block";
    target.style.objectFit = "contain";
    target.style.scale = "0.7";
  }
  public getPreviewUrl() {
    switch (this.type) {
      case ESwitcherAssetType.Gfx:
        return "assets/thumbnails/graphic.svg";
      case ESwitcherAssetType.Layout:
        return "assets/thumbnails/layout.svg";
      case ESwitcherAssetType.Media:
        return "assets/thumbnails/media.svg";
      case ESwitcherAssetType.LiveFeed:
        return "assets/thumbnails/live-feed.svg";
      default:
        return "assets/thumbnails/empty.svg";
    }
  }
  public itemStats() {
    let html = `<div class="media-stats">`;

    // Add asset name
    html += `<div class="stat-row"><span class="stat-key">Name: </span><span class="stat-value">${this.assetName}</span></div>`;

    // Add asset type
    const typeString = ESwitcherAssetType[this.type];
    const formattedType = typeString.replace(/([A-Z])/g, " $1").trim();
    html += `<div class="stat-row"><span class="stat-key">Type: </span><span class="stat-value">${formattedType}</span></div>`;

    // Add duration if available
    if (this.formattedDuration) {
      html += `<div class="stat-row"><span class="stat-key">Duration: </span><span class="stat-value">${this.formattedDuration}</span></div>`;
    }

    // Add SOM if available
    if (this.formattedSOM) {
      html += `<div class="stat-row"><span class="stat-key">SOM: </span><span class="stat-value">${this.formattedSOM}</span></div>`;
    }
    // Add assets count if item is block
    if (this.type == ESwitcherAssetType.Block) {
      html += `<div class="stat-row"><span class="stat-key">Assets Count: </span><span class="stat-value">${this.assetsCount}</span></div>`;
    }

    html += `</div>`;
    return html;
  }
  public async changeBlockType(broadcastUid: string) {
    this.type = this.isStack
      ? ESwitcherAssetType.Block
      : ESwitcherAssetType.Stack;
    await this._broadcastsPresetsRepository.changeBlockType(this, broadcastUid);
  }
  public testAssetItemVisibility(showUid: string) {
    var data = this.data as assetBlockItemExtendedData;
    if (!data.assets) return true;
    const ed = data.getBroadcastAssetItem(this.uid);
    return ed.assetsVisibility[showUid] ?? true;
  }
  public onBlockItemAssetVisibilityChange(
    broadcastUid: string,
    showUid: string,
  ) {
    var data = this.data as assetBlockItemExtendedData;
    if (!data.assets) return;
    const ed = data.getBroadcastAssetItem(this.uid);
    ed.assetsVisibility[showUid] = !(ed.assetsVisibility[showUid] ?? true);
    this.updateBlockExtendedData(broadcastUid);
  }
  public updateBlockExtendedData(broadcastUid: string) {
    const originalData = this.data as assetBlockItemExtendedData;
    const filteredData = new assetBlockItemExtendedData(originalData.assets, {
      [this.uid]: originalData.broadcastAssetItems[this.uid],
    });

    this._broadcastsPresetsRepository.updateBlockExtendedData(
      broadcastUid,
      this.assetId,
      this.uid,
      filteredData,
    );

    // Notify subscribers (e.g. the switcher tile) so they re-render immediately
    // without waiting for a SignalR round-trip.
    this.dataChanged$.next();
  }

  public destroy() {
    this.dataChanged$.complete();
  }
}
